/**
 * FT12-U18: Unallocated Receipts (FSD 2.2.3.10). The INT packet spreads
 * `AR_UNALLOCATED_RECEIPTS_ROUTES` and adds the nav item `ar-unallocated-receipts`. The
 * route's permission is the report endpoint's: `ar.receipt.read`. Resolves FT9's NoScreen
 * deeplink marker for `/ar/reports/unallocated-receipts` (the unallocated alert links here).
 */

import type { RouteRecordRaw } from 'vue-router'

import { AR_PERMISSIONS } from '@/modules/ar/permissions'

export const AR_UNALLOCATED_RECEIPTS_ROUTES: RouteRecordRaw[] = [
  {
    path: '/ar/reports/unallocated-receipts',
    name: 'ar-unallocated-receipts',
    component: () => import('@/modules/ar/reports/unallocated-receipts/UnallocatedReceiptsView.vue'),
    meta: {
      titleKey: 'ar.routeTitles.unallocatedReceipts',
      permission: AR_PERMISSIONS.receiptRead,
    },
  },
]
